import { DocumentAiSummariesData } from '@/recoil/atom/documents';

export const INIT_DOCUMENTS_SUMMARIES_DATA: DocumentAiSummariesData = {};
